<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/assign/${projectId}`">
      </f7-nav-left>
      <f7-nav-title>{{ project.name }}</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="add">发布</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <release-Header :project="this.project.projectRootVO || {}"></release-Header>
    <div class="has-content">
      <f7-link @click="splitExpanded = !splitExpanded">
        <div class="split-item-title">
          <div>分包信息</div>
          <div>
            <f7-icon :fa="splitExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
          </div>
        </div>
      </f7-link>
      <div v-show="splitExpanded">
        <f7-list inline-labels id="releaseSplitForm">
          <f7-list-input
            label="工程名称"
            type="text"
            :value="project.name"
            @input="project.name = $event.target.value"
            placeholder="请填写"
            required
            validate
            minlength=2
            maxlength=50
            error-message='长度2-50字符'>
            <div slot="media" class="input-required">*</div>
          </f7-list-input>
          <f7-list-item>
            <div slot="media" class="input-required">&nbsp;</div>
            <div slot="inner" class="item-title item-label">承(分)包单位</div>
            <div class="item-after">{{ project.dutyCompanyName }}</div>
          </f7-list-item>
          <f7-list-item link="" @click="scopePopupOpened = true">
            <div slot="media" class="input-required">*</div>
            <div slot="inner" class="item-title item-label">承(分)包范围</div>
            <div class="item-after popup-smart-select">{{ scopeDisplayVal }}</div>
            <f7-popup :opened="scopePopupOpened" @popup:closed="scopePopupOpened = false">
              <scope
                :dictKey="dictKey"
                :opened="scopePopupOpened"
                :result.sync="dutyScopeList">
              </scope>
            </f7-popup>
          </f7-list-item>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">开工日期</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="calendar-startTime"
              readonly
              required
              validate />
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">竣工日期</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="calendar-finishTime"
              readonly
              required
              validate/>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">工程规模</div>
            <div style="display: flex;">
              <div>
                <input
                  :value="project.projectSize"
                  @input="project.projectSize = $event.target.value"
                  type="number"
                  placeholder="请填写"
                  required
                  validate
                  min=0.00
                  max=100000000.00
                  step="0.01"
                  data-error-message='支持两位小数'/>
              </div>
              <input type="text"
                placeholder="请选择"
                id="picker-sizeUnit"
                readonly
                required
                validate
                style="max-width: 4rem;"/>
            </div>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">所需人数</div>
            <input
              slot="input"
              :value="project.needUserNumber"
              @input="project.needUserNumber = $event.target.value"
              type="text"
              required
              validate
              data-error-message='必选项'
              placeholder="请填写"/>
            <div slot="inner-end" style="min-width: 3rem; text-align: right;">人</div>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">分包方式</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="picker-subpackageMode"
              readonly
              required
              validate/>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">结算方式</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="picker-settlement"
              readonly
              required
              validate/>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">分包单价</div>
            <div slot="input" style="display: flex;">
              <div>
                <input
                  type="number"
                  :value="project.prePrice"
                  @input="project.prePrice = $event.target.value"
                  placeholder="请填写"
                  required
                  validate
                  min=0.00
                  max=100000000.00
                  step="0.01"
                  data-error-message='支持两位小数'/>
              </div>
              <input
                type="text"
                readonly
                required
                placeholder="请选择"
                id="picker-priceUnit"
                style="max-width: 4rem;" />
            </div>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">付款方式</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="picker-payMethod"
              readonly
              required
              validate/>
          </f7-list-input>
          <f7-list-item link="" @click="assistMaterialsPopupOpened = true">
            <div slot="media" class="input-required">&nbsp;</div>
            <div slot="inner" class="item-title item-label">辅料</div>
            <div class="item-after popup-smart-select">{{ assistMaterialsDisplay }}</div>
            <f7-popup
              :opened="assistMaterialsPopupOpened"
              @popup:closed="assistMaterialsPopupOpened = false">
              <popup-select
                title="辅料"
                :data="assistMaterialsList"
                :result.sync="project.assistMaterials">
              </popup-select>
            </f7-popup>
          </f7-list-item>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">&nbsp;</div>
            <div slot="label">质量标准</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="picker-qualityStandard"
              readonly
              required
              validate/>
          </f7-list-input>
          <f7-list-item
            title="队伍类型"
            link=""
            @click="teamPopupOpened = true">
            <div slot="media" class="input-required">*</div>
            <div slot="after">{{ teamDisplay }}</div>
            <f7-popup :opened="teamPopupOpened" @popup:closed="teamPopupOpened = false">
              <popup-radio
                title="队伍类型"
                :data="companyTypeList"
                :result.sync="project.projectPublishVO.receptCompanyType">
              </popup-radio>
            </f7-popup>
          </f7-list-item>
          <f7-list-item
            title="专业特长"
            link=""
            @click="featuresPopupOpened = true">
            <div slot="media" class="input-required">*</div>
            <div slot="after">{{ featuresDisplay }}</div>
            <f7-popup :opened="featuresPopupOpened" @popup:closed="featuresPopupOpened = false">
              <popup-radio
                search="true"
                title="专业特长"
                :data="featuresList"
                :result.sync="project.projectPublishVO.receptFeatures">
              </popup-radio>
            </f7-popup>
          </f7-list-item>
          <f7-list-input
            label="分包说明"
            type="textarea"
            :value="project.projectPublishVO.dutyRemark"
            @input="project.projectPublishVO.dutyRemark = $event.target.value"
            placeholder="请填写"
            resizable>
            <div slot="media" class="input-required">&nbsp;</div>
          </f7-list-input>
        </f7-list>
      </div>
    </div>
    <div class="has-content" style="margin-top: -1.5rem;">
      <f7-link @click="contactExpanded = !contactExpanded">
        <div class="split-item-title">
          <div>联系方式</div>
          <div>
            <f7-icon :fa="contactExpanded ? 'angle-up' : 'angle-right'"></f7-icon>
          </div>
        </div>
      </f7-link>
      <div v-show="contactExpanded">
        <f7-list inline-labels id="releaseSplitContactForm">
          <f7-list-input
            label="联系人"
            type="text"
            :value="project.projectPublishVO.contactpeopleName"
            @input="project.projectPublishVO.contactpeopleName = $event.target.value"
            required
            validate
            minlength=2
            maxlength=50
            error-message='长度2-50字符'
            placeholder="请填写">
            <div slot="media" class="input-required">*</div>
          </f7-list-input>
          <f7-list-input
            label="联系电话"
            type="text"
            :value="project.projectPublishVO.contactpeoplePhone"
            @input="project.projectPublishVO.contactpeoplePhone = $event.target.value"
            required
            validate
            minlength=8
            maxlength=50
            error-message='电话或手机号格式不正确'
            placeholder="请填写">
           <div slot="media" class="input-required">*</div>
          </f7-list-input>
          <f7-list-input :input="false">
            <div slot="media" class="input-required">*</div>
            <div slot="label">截止日期</div>
            <input
              slot="input"
              type="text"
              placeholder="请选择"
              id="calendar-validityDate"
              readonly
              required
              validate/>
          </f7-list-input>
        </f7-list>
      </div>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { createPicker, createCalendar, createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getDict } from '@/api/common';
import { getReleaseNormal, releaseNormal } from '@/api/team/worker';
import { SplitProject } from '@/model/reqObject';
import Scope from '@/components/Scope';
import PopupSelect from '@/components/PopupSelect';
import PopupRadio from '@/components/PopupRadio';
import ReleaseHeader from '@/components/ReleaseHeader';

export default {
  props: ['projectId'],
  components: {
    Scope,
    PopupSelect,
    PopupRadio,
    ReleaseHeader,
  },
  data() {
    return {
      subpackageTypeList: [],
      dutyScopeList: [],
      projectSizeUnitList: [],
      subpackageModeList: [],
      settlementList: [],
      priceUnitList: [],
      assistMaterialsList: [],
      payMethodList: [],
      qualityStandardList: [],
      project: Object.assign(new SplitProject(), {
        validityDate: '',
        projectRootVO: {},
        projectPublishVO: {},
      }),
      scopePopupOpened: false,
      assistMaterialsPopupOpened: false,
      perms: {},
      splitExpanded: true,
      contactExpanded: true,
      companyTypeList: [],
      featuresList1: [],
      featuresList2: [],
      teamPopupOpened: false,
      featuresPopupOpened: false,
    };
  },
  mounted() {
    const dictKeys = [
      'subpackageType', 'projectSizeUnit', 'subpackageMode',
      'projectSettlement', 'priceUnit', 'assistMaterials', 'payMethod', 'qualityStandard',
    ];
    Promise.all([
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.subpackageTypeList = result.data.subpackageType.codeVoList || [];
        this.projectSizeUnitList = result.data.projectSizeUnit.codeVoList || [];
        this.subpackageModeList = result.data.subpackageMode.codeVoList || [];
        this.settlementList = result.data.projectSettlement.codeVoList || [];
        this.priceUnitList = result.data.priceUnit.codeVoList || [];
        this.assistMaterialsList = result.data.assistMaterials.codeVoList || [];
        this.payMethodList = result.data.payMethod.codeVoList || [];
        this.qualityStandardList = result.data.qualityStandard.codeVoList || [];
      }),
      getDict({ typeCodes: ['companyType'] }).then((result) => {
        this.companyTypeList = result.data.companyType.codeVoList || [];
      }),
      getDict({ typeCodes: ['laborBizScope'] }).then((result) => {
        this.featuresList2 = result.data.laborBizScope.codeVoList || [];
      }),
      getDict({ typeCodes: ['professBizScope'] }).then((result) => {
        this.featuresList1 = result.data.professBizScope.codeVoList || [];
      }),
    ]).then(() => this.getInfo());
  },
  computed: {
    dictKey() {
      return this.project.projectRootVO.projectType;
    },
    scopeDisplayVal() {
      return this.dutyScopeList.join(', ');
    },
    assistMaterialsDisplay() {
      return this.assistMaterialsList
        .filter(item => this.project.assistMaterials.includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
    workerBenefitsDisplay() {
      return this.workerBenefitsList
        .filter(item => this.project.workerBenefits.includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
    teamDisplay() {
      return this.companyTypeList
        .filter(item => item.code === this.project.projectPublishVO.receptCompanyType)
        .map(item => item.name)
        .join(',');
    },
    featuresDisplay() {
      return this.featuresList
        .filter(item => item.code === this.project.projectPublishVO.receptFeatures)
        .map(item => item.name)
        .join(',');
    },
    featuresList() {
      if (this.project.projectPublishVO.receptCompanyType === 'specialtyTeam'
        || this.project.projectPublishVO.receptCompanyType === 'specialtyCompany') {
        return this.featuresList1;
      } else if (this.project.projectPublishVO.receptCompanyType === 'laborCompany'
        || this.project.projectPublishVO.receptCompanyType === 'integrateLaborTeam') {
        return this.featuresList2;
      } else if (this.project.projectPublishVO.receptCompanyType === 'buildingCompany') {
        return [];
      }
      return [];
    },
  },
  methods: {
    getInfo() {
      getReleaseNormal({ projectId: this.projectId }).then((result) => {
        this.project = Object.assign(new SplitProject(result.data), {
          validityDate: (result.data.projectRootVO || {}).validityDate || '',
          projectRootVO: result.data.projectRootVO || {},
          projectPublishVO: result.data.projectPublishVO || {},
        });
        if (!lodash.isEmpty(this.project.dutyScope)) {
          this.dutyScopeList = this.project.dutyScope.split('||');
        }
        this.init();
        this.perms = result.perms || {};
      });
    },
    setErrorMsg(elem) {
      elem.addClass('input-invalid');
      let tmpNode = elem;
      while (this.$$(tmpNode).parent() && this.$$(tmpNode).parent().length !== 0) {
        if (tmpNode.hasClass('item-content')) {
          tmpNode.addClass('item-input-with-error-message');
          tmpNode.addClass('item-input-invalid');
          break;
        } else {
          tmpNode = this.$$(tmpNode).parent();
        }
      }
    },
    add() {
      // this.$f7.input.validateInputs('#splitForm');
      // this.$f7.input.validateInputs('#releaseSplitContactForm');
      if (lodash.isEmpty(this.project.planStartupTime)) {
        this.setErrorMsg(this.$$('#calendar-startTime'));
      }
      if (lodash.isEmpty(this.project.planCompletedTime)) {
        this.setErrorMsg(this.$$('#calendar-finishTime'));
      }
      if (lodash.isEmpty(this.project.sizeUnit)) {
        this.setErrorMsg(this.$$('#picker-sizeUnit'));
      }
      if (lodash.isEmpty(this.project.subpackageMode)) {
        this.setErrorMsg(this.$$('#picker-subpackageMode'));
      }
      if (lodash.isEmpty(this.project.settlement)) {
        this.setErrorMsg(this.$$('#picker-settlement'));
      }
      if (lodash.isEmpty(this.project.priceUnit)) {
        this.setErrorMsg(this.$$('#picker-priceUnit'));
      }
      if (lodash.isEmpty(this.project.payMethod)) {
        this.setErrorMsg(this.$$('#picker-payMethod'));
      }
      if (!lodash.gte(this.project.planStartupTime,
        dateFormat(this.project.projectRootVO.planStartupTime))) {
        createToast(this, '开始日期必须大于等于上级任务的开始日期');
        return;
      }
      if (!lodash.lte(this.project.planCompletedTime,
        dateFormat(this.project.projectRootVO.planCompletedTime))) {
        createToast(this, '结束日期必须小于等于上级任务的结束日期');
        return;
      }
      if (lodash.isEmpty(this.project.projectPublishVO.receptCompanyType)) {
        createToast(this, '队伍类型不能为空');
        return;
      }
      if (lodash.gte(this.project.projectPublishVO.receptFeatures)) {
        createToast(this, '专业特长不能为空');
        return;
      }
      if (!lodash.gte(this.project.validityDate, dateFormat(new Date()))) {
        createToast(this, '截止日期必须大于等于当前日期');
        return;
      }
      let valided = true;
      this.$$('#splitForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      this.$$('#releaseSplitContactForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (!valided) {
        return;
      }
      this.$set(this.project, 'dutyScope', this.dutyScopeList.join('||'));
      this.$set(this.project.projectPublishVO, 'validityDate', this.project.validityDate);
      releaseNormal(this.project).then((data) => {
        if (data.code === 0) {
          createToast(this, '发布成功');
          this.$f7router.back(`/project/assign/${this.projectId}`);
        }
      });
    },
    init() {
      createPicker(
        this,
        '#picker-subpackageType',
        this.subpackageTypeList.map(d => d.code),
        this.subpackageTypeList.map(d => d.name),
        'project',
        'subpackageType',
      );
      createCalendar(this, '#calendar-startTime', 'project', 'planStartupTime');
      createCalendar(this, '#calendar-finishTime', 'project', 'planCompletedTime');
      createPicker(
        this,
        '#picker-sizeUnit',
        this.projectSizeUnitList.map(d => d.code),
        this.projectSizeUnitList.map(d => d.name),
        'project',
        'sizeUnit',
      );
      createPicker(
        this,
        '#picker-subpackageMode',
        this.subpackageModeList.map(d => d.code),
        this.subpackageModeList.map(d => d.name),
        'project',
        'subpackageMode',
      );
      createPicker(
        this,
        '#picker-settlement',
        this.settlementList.map(d => d.code),
        this.settlementList.map(d => d.name),
        'project',
        'settlement',
      );
      createPicker(
        this,
        '#picker-priceUnit',
        this.priceUnitList.map(d => d.code),
        this.priceUnitList.map(d => d.name),
        'project',
        'priceUnit',
      );
      createPicker(
        this,
        '#picker-payMethod',
        this.payMethodList.map(d => d.code),
        this.payMethodList.map(d => d.name),
        'project',
        'payMethod',
      );
      createPicker(
        this,
        '#picker-qualityStandard',
        this.qualityStandardList.map(d => d.code),
        this.qualityStandardList.map(d => d.name),
        'project',
        'qualityStandard',
      );
      createCalendar(this, '#calendar-validityDate', 'project', 'validityDate');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .split-item-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.5rem;
    background-color: $panel-bg-color;
    font-size: 1rem;
  }

  .popup-smart-select {
    max-width: 63%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  input.input-invalid::placeholder {
    color: #ff3b30;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/releaseNormal.vue